"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterNameInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ParameterNameInput = (props) => {
    const { name = "parameterName" } = props;
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: name });
};
exports.ParameterNameInput = ParameterNameInput;
//# sourceMappingURL=index.js.map